
import { useState, useEffect } from "react";
import { ConsultarIPedidosEncomenda } from "../funcionalidades/bancoGet";
import GlobalVar from "./GlobalVar";
import { copiarLink } from "../funcionalidades/copiarLink";


const compartilhar = async (pedido, avisar = false) => {
  const url = `https://encomendas.babita.com.br/PedidoRelatorioCliente?doc=${pedido}`;

  if (navigator.share) {
    try {
      await navigator.share({
        title: "Pedido",
        text: "Veja esse pedido",
        url: url,
      });
    } catch (err) {
      console.log("Erro ao compartilhar:", err);
    }
  } else {
    // fallback (desktop ou navegador antigo)
    await copiarLink(url, { avisar });
  }
};

const ComponenteNotaVendedora = ({item, ativaResp, setShowAlert, usuarioTipo})=>{

    const [showItens, setShowItens] = useState(false)
    const [itensNota, setItensNota] = useState('Carregando ...')

    let data = GlobalVar.formatarData(new Date((item.data)))
    let dataCab = `${data[0]}/${data[1]}/${data[2]}`
    let dataItem = `${data[2]}-${data[1]}-${data[0]}`
    // const item = {...JSON.parse(JSON.stringify(item)), tipo: item.tipo
    //     destino}


    useEffect(()=>{
        if(showItens){
                ConsultarIPedidosEncomenda({documento: item.documento})
                    .then((resp)=>{
                        if(resp.Error){
                            setShowAlert(resp.Error);
                        }else{
                            const respostaTratada = resp.reduce((acc, curr) => {
                                if(!acc[curr.rev_nom]) {
                                    acc[curr.rev_nom] = [];
                                }
                                acc[curr.rev_nom].push(curr);
                                return acc;
                            }, {});
                            setItensNota(respostaTratada)
                        }
                        
                    })
        }
    },[showItens])
    

    return <div className="itemNota vendedora">
        <div className={`cabecalhoNota `} onClick={()=>setShowItens(!showItens)}>
            {/* <div>{index}</div> */}
            {ativaResp ? <>
                <div>Doc.:&nbsp;{item.documento}</div>
                <div>{item.doctoclie}</div>
                <div>{item.nomeclie.split(" ").slice(0,3).join(" ").slice(0,20)}</div>
                <div>Qtde. Total:{" "+item.totalitens}</div>

            <div>Total: {GlobalVar.converteReais(item.totalgeral)}</div>
            <div>{dataCab}</div>
            </> : 
            <>
                <div>{item.documento}</div>

                <div>{item.doctoclie}</div>
                <div>{item.nomeclie.split(" ").slice(0,3).join(" ").slice(0,20)}</div>


                <div>{item.totalitens}</div>

                <div>{GlobalVar.converteReais(item.totalgeral)}</div>
                <div>{dataCab}</div>
                </>}
        </div>

        {showItens ? <button className="compartilharNota"  onClick={()=>compartilhar(item.documento, true)}>
                              Compartilhar
                            </button> : <></>}
                            
                            
        {showItens ?<div className="itensNota">
             <div className='lineBar'></div>
             
            {itensNota !== 'Carregando ...' ? Object.keys(itensNota).map((revistaColecaoItens,i)=>{
                    const itensArr = itensNota[revistaColecaoItens]
                    
                    return  <>
                    <div className="titleRevMov" key={`title${item.documento}`}>{revistaColecaoItens}</div>

                        <div className="itemsMov" key={`itens${item.documento}`}>
                            {itensArr.map((subItem,i)=>{
                               return <>
                                <div className="subItemMov" key={`subItens${item.documento}`}>
                                    <div>{subItem.fabricante.substr(0,24)}</div>
                                    <div>{subItem.item.substr(0,24)}</div>
                                    <div>{parseInt(subItem.desconto) !== 0 ? `De: ${GlobalVar.converteReais(subItem.prcbasico)}` : ''}</div>
                                    <div>Por: {`${GlobalVar.converteReais(subItem.prcvenda)}`}</div>
                                    
                                    <div>{`${subItem.qtde}`} UN</div>
                                    
                                    <div>Subtotal:{`${GlobalVar.converteReais(parseFloat(subItem.prcvenda)*parseInt(subItem.qtde))}`}</div>
                                        
                                </div>
                                <div className='lineBar'></div>
                            </>
                            })}
                            <div className="totalItemMov">
                                <div>Items: {`${itensArr.reduce((acc, curr) => {
                                            return acc + parseInt(curr.qtde);
                                        }, 0)}`}</div>
                                <div>Total: R$ {`${itensArr.reduce((acc, curr) => {
                                            return acc + parseFloat(curr.prcvenda)*parseInt(curr.qtde);
                                        }, 0).toFixed(2)}`.replaceAll(".",",")}</div>
                            </div>
                            
                        </div>
                        </> 
                    }) : 'Carregando ...'}  
        </div> : <></>}
    </div>
}

export default ComponenteNotaVendedora;